/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../summaryStyle";
import Typography from "@mui/material/Typography";
import SummaryDetailsItem from "../../Common/SummaryDetailsItem/SummaryDetailsItem";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";

type PersonDataProps = {
  personType: string;
  title: string;
  product: AbstractCase;
};

const PersonData = ({ personType, title, product }: PersonDataProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h5"}>{title}</Typography>
      </Grid>
      <SummaryDetailsItem caseData={product} fieldPath={`${personType}.gender`} />
      <SummaryDetailsItem caseData={product} fieldPath={`${personType}.givenName`} />
      <SummaryDetailsItem caseData={product} fieldPath={`${personType}.familyName`} />
      <SummaryDetailsItem caseData={product} fieldPath={`${personType}.nationality`} />
      <SummaryDetailsItem caseData={product} fieldPath={`${personType}.residenceAddress.streetAddress`} />
      <SummaryDetailsItem caseData={product} fieldPath={`${personType}.residenceAddress.postalCode`} />
      <SummaryDetailsItem caseData={product} fieldPath={`${personType}.residenceAddress.addressLocality`} />
    </>
  );
};

export default PersonData;
